export default function reducer(
    state = {
        status: 'uninitiated',
        result: {},
    },
    action
) {
    switch (action.type) {
        case 'DUPLICATE_CUSTOMER_PLAYLIST_INITIATED': {
            return { ...state, status: 'initiated' };
        }
        case 'DUPLICATE_CUSTOMER_PLAYLIST_SUCCESS': {
            return { ...state, status: 'success', result: action.payload };
        }
        case 'DUPLICATE_CUSTOMER_PLAYLIST_FAILED': {
            return { ...state, status: 'failed', result: action.payload };
        }
        default: {
            return state;
        }
    }
}